import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { take } from 'rxjs/operators';
import { Cd003CardIComponent } from './cd003-card-I.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-cd003-card-IV',
    templateUrl: './cd003-card-IV.component.html',
    styleUrls: ['../list-form-cd003.component.scss']
})

export class Cd003CardIVComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listRepasseColorSendoDescartado?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listRepasseColorSendoDescartadoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listMedidor?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listMedidorOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public siteSelect: string = localStorage.getItem('site-select') || null;
    public disabledBtnEditar: boolean = false;
    public isPTU: boolean;
    public hiddenButtonEditar: boolean;

    @ViewChild(Cd003CardIComponent, { static: false }) cd003CardIComponent: Cd003CardIComponent;
    @Output() mkCalc = new EventEmitter();
    @Output() makeCalcII = new EventEmitter();
    @Output() mkEditButton = new EventEmitter();
    disableField = false
    changeFieldName = false
    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Medição de Vazão', false);
        if (this.isComercial) {
            this.formulario = this.formBuilder.group({
                repasse_color_sendo_descartado: [null, []],
                peso_g_semente_boa_dez_segundos: [null, []],
                peso_g_descarte_dez_segundos_coluna_ar: [null, []],
                peso_g_descarte_dez_segundos_color_sorter: [null, []],
                peso_g_descarte_dez_segundos_densimetrica: [null, []],
                vazao_semente_boa_color_sorter_ton_h: [null, [Validators.min(0), Validators.max(15)]],
                vazao_descarte_coluna_ar_kg_h: [null, []],
                vazao_descarte_color_sorter_kg_h: [null, []],
                vazao_descarte_densimetrica_kg_h: [null, []],
                medidor_vazao: ['NAO', []],
            });
        }
        else {
            this.formulario = this.formBuilder.group({
                //repasse_color_sendo_descartado: [null, []],
                peso_g_semente_boa_cinco_segundos: [null, [Validators.required]],
                // peso_g_semente_boa_dez_segundos: [null, []],
                peso_g_descarte_sessenta_segundos_coluna_ar: [null, [Validators.required]],
                //peso_g_descarte_dez_segundos_coluna_ar: [null, []],
                peso_g_descarte_sessenta_segundos_color_sorter: [null, [Validators.required]],
                peso_g_descarte_dez_segundos_color_sorter: [null, []],
                // peso_g_descarte_dez_segundos_densimetrica: [null, []],
                peso_g_descarte_sessenta_segundos_coluna_ar2: [null, [Validators.required]],
                vazao_semente_boa_color_sorter_ton_h: [null, []],
                vazao_descarte_coluna_ar_kg_h: [null, []],
                vazao_descarte_color_sorter_kg_h: [null, []],
                vazao_descarte_densimetrica_kg_h: [null, []],
                medidor_vazao: [null, []],
            });
        }
    }


    public async ngOnInit(): Promise<void> {
        await this.getLists();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    // public async editBtn(): Promise<void>{
    //   this.disabledBtnEditar = false;
    //   console.log('clicou')
    // }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await this.getListRepasseColorSendoDescartado();
        await this.getListMedidorVazao();
    }



    async getListRepasseColorSendoDescartado(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'ultima_carga').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listRepasseColorSendoDescartado = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listRepasseColorSendoDescartadoOriginal = this.listRepasseColorSendoDescartado;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, 'Erro para buscar do banco de dados para montagem da lista de Repasse da Color Sendo Descartado');
        });
    }

    createFilterRepasseColorSendoDescartado(value?: string): void {
        if (!!value && value.length > 0) {
            if (this.listRepasseColorSendoDescartadoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listRepasseColorSendoDescartado = this.listRepasseColorSendoDescartadoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listRepasseColorSendoDescartado = this.listRepasseColorSendoDescartadoOriginal;
            }
        } else {
            this.listRepasseColorSendoDescartado = this.listRepasseColorSendoDescartadoOriginal;
        }
    }

    verificarVazaoSementeBoa() {
        const vazao = this.formulario.get('vazao_semente_boa_color_sorter_ton_h').value;
        const limiteInferior = 3;
        const limiteSuperior = 15;

        if (vazao !== null && vazao >= limiteInferior && vazao <= limiteSuperior) {
            this.formulario.get('peso_g_descarte_dez_segundos_coluna_ar').setErrors(null);
            this.formulario.get('peso_g_descarte_dez_segundos_color_sorter').setErrors(null);
            this.formulario.get('peso_g_descarte_dez_segundos_densimetrica').setErrors(null);
            this.formulario.get('peso_g_semente_boa_dez_segundos').setErrors(null);

        } else {
            this.formulario.get('peso_g_descarte_dez_segundos_coluna_ar').setErrors({ invalidSorter: true });
            this.formulario.get('peso_g_descarte_dez_segundos_color_sorter').setErrors({ invalidSorter: true });
            this.formulario.get('peso_g_descarte_dez_segundos_densimetrica').setErrors({ invalidSorter: true });
            this.formulario.get('peso_g_semente_boa_dez_segundos').setErrors({ invalidSorter: true });
        }

        this.makeCalculations();
        this.mkCalcII();


    }

    async getListMedidorVazao(): Promise<void> {
        await this.formularioService.getListDropDownList('cd003', 'medidor_vazao').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listMedidor = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listMedidorOriginal = this.listMedidor;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, 'Erro para buscar do banco de dados para montagem da lista de Repasse da Color Sendo Descartado');
        });
    }

    createFilterMedidorVazao(value?: string): void {
        if (!!value && value.length > 0) {
            if (this.listMedidorOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listMedidor = this.listMedidorOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listMedidor = this.listMedidorOriginal;
            }
        } else {
            this.listMedidor = this.listMedidorOriginal;
        }
    }

    disableFields($event: any) {
        const medidor = this.formulario.get('medidor_vazao')?.value?.trim()?.toUpperCase();
        if (medidor === 'SIM') {
            this.disableField = true
            this.hiddenButtonEditar = true
            this.formulario.get('peso_g_descarte_dez_segundos_color_sorter').setErrors(null);
            this.formulario.get('peso_g_semente_boa_dez_segundos').setValue(null);
        } else {

            this.disableField = false
            this.hiddenButtonEditar = false
        }
    }


    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async mkCalcII(): Promise<void> {

        this.makeCalcII.emit();

    }

    async mkCalcIII(): Promise<void> {
        this.makeCalcII.emit();
    }

    async makeEditBtn(): Promise<void> {
        this.mkEditButton.emit();
    }
}

